module.exports = __webpack_public_path__ + "static/media/focus-target.65c16c3a.svg";